'use strict';

var React = require('react');
var withStyles = require('../../DesignSystem/Styles/withStyles.js');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var PriceDetails = require('./PriceDetails.js');
var ProContact = require('./ProContact.js');
var RequestAmountUtils = require('../../utils/RequestAmountUtils.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Hidden = require('../../node_modules/@material-ui/core/esm/Hidden/Hidden.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  messageFromPro: {
    textAlign: 'justify'
  }
};

var OptionInvoiceFooter = function OptionInvoiceFooter(props) {
  var _discounts$percentage;

  var organization = props.organization,
      tax = props.tax,
      discounts = props.discounts,
      option = props.option,
      settings = props.settings,
      isPresenting = props.isPresenting,
      hasLineItems = props.hasLineItems,
      lendingPromo = props.lendingPromo,
      classes = props.classes;
  var company_name = organization.company_name,
      phone_number = organization.phone_number,
      email = organization.email,
      address = organization.address;
  var sub_total = option.sub_total,
      total_amount = option.total_amount,
      message_from_pro = option.message_from_pro;
  var show_message_from_pro = settings.show_message_from_pro;
  var discountName = ObjectHelper.isPresent(discounts.fixed_discounts) ? discounts.fixed_discounts[0].name : discounts === null || discounts === void 0 ? void 0 : (_discounts$percentage = discounts.percentage_discount) === null || _discounts$percentage === void 0 ? void 0 : _discounts$percentage.name;
  var proContact = isPresenting ? null : React__default["default"].createElement(ProContact, {
    name: company_name,
    phone: phone_number,
    email: email,
    address: address,
    settings: settings
  });
  var priceDetails = hasLineItems ? React__default["default"].createElement(PriceDetails, {
    subtotal: sub_total,
    discount: RequestAmountUtils.calculateDiscountAmount(discounts, sub_total),
    discountName: discountName,
    taxName: tax.name,
    taxRate: tax.rate,
    taxAmount: tax.amount,
    totalAmount: total_amount,
    lendingPromoAmount: lendingPromo.monthly_amount
  }) : null;
  return React__default["default"].createElement(Grid, {
    container: true,
    item: true,
    alignItems: "flex-start",
    spacing: 3
  }, React__default["default"].createElement(Hidden, {
    xsDown: true
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 7
  }, proContact), React__default["default"].createElement(Grid, {
    item: true,
    xs: 5
  }, priceDetails), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, show_message_from_pro && React__default["default"].createElement(Typography, {
    color: "textSecondary",
    className: classes.messageFromPro
  }, message_from_pro))), React__default["default"].createElement(Hidden, {
    smUp: true
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, priceDetails), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, proContact, show_message_from_pro && React__default["default"].createElement(Typography, {
    color: "textSecondary",
    className: classes.messageFromPro
  }, message_from_pro))));
};

var OptionInvoiceFooter$1 = withStyles["default"](styles)(OptionInvoiceFooter);

module.exports = OptionInvoiceFooter$1;
